module.exports = __webpack_public_path__ + "img/file-earmark-word-fill.f32b5497.svg";